import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "loading-circle" }
const _hoisted_2 = { style: {"display":"contents","width":"106px"} }
const _hoisted_3 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  id: "Calque_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 2000 2000",
  style: {"enable-background":"new 0 0 2000 2000","width":"250px"},
  "xml:space": "preserve"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "loading-page d-flex align-center justify-center fill-height" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "d-flex align-center justify-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "d-flex align-center justify-center"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_progress_circular, {
                  size: "256",
                  width: "4",
                  indeterminate: "",
                  value: _ctx.progress
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_container, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "text-center",
                              style: {"margin":"-70px 0"}
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                  (_openBlock(), _createElementBlock("svg", _hoisted_3, _cache[0] || (_cache[0] = [
                                    _createElementVNode("g", null, [
                                      _createElementVNode("path", {
                                        class: "st0 wing",
                                        d: "M1019.61,800.94c37.04,63.21-12.98,149.51-12.98,149.51s-110.08-16.18-147.12-79.38      c-37.05-63.21-31.23-130.14,12.98-149.51C916.7,702.19,982.57,737.73,1019.61,800.94"
                                      }),
                                      _createElementVNode("path", {
                                        class: "st0 wing",
                                        d: "M1146.69,862.93c-31.89,65.27-140.41,88-140.41,88s-56.81-83.1-24.92-148.37c31.89-65.27,94.76-104.67,140.41-88      C1167.43,731.23,1178.59,797.66,1146.69,862.93"
                                      }),
                                      _createElementVNode("path", {
                                        class: "st1",
                                        d: "M1127.44,1289.27H849.51c-94.27,0-170.69-76.42-170.69-170.69v-0.92c0-94.27,76.42-170.69,170.69-170.69   h277.93c94.27,0,170.69,76.42,170.69,170.69v0.92C1298.13,1212.85,1221.71,1289.27,1127.44,1289.27"
                                      }),
                                      _createElementVNode("path", { d: "M1150.49,1289.27H909.73c-94.27,0-170.69-76.42-170.69-170.69v-0.92c0-94.27,76.42-170.69,170.69-170.69h240.77   c94.27,0,170.69,76.42,170.69,170.69v0.92C1321.18,1212.85,1244.76,1289.27,1150.49,1289.27" }),
                                      _createElementVNode("path", {
                                        class: "st1",
                                        d: "M1150.49,1289.27H969.95c-94.27,0-170.69-76.42-170.69-170.69v-0.92c0-94.27,76.42-170.69,170.69-170.69   h180.55c94.27,0,170.69,76.42,170.69,170.69v0.92C1321.18,1212.85,1244.76,1289.27,1150.49,1289.27"
                                      }),
                                      _createElementVNode("path", { d: "M1150.49,1289.27h-120.33c-94.27,0-170.69-76.42-170.69-170.69v-0.92c0-94.27,76.42-170.69,170.69-170.69h120.33   c94.27,0,170.69,76.42,170.69,170.69v0.92C1321.18,1212.85,1244.76,1289.27,1150.49,1289.27" }),
                                      _createElementVNode("path", { d: "M1150.49,1289.27h-60.11c-94.27,0-170.69-76.42-170.69-170.69v-0.92c0-94.27,76.42-170.69,170.69-170.69h60.11   c94.27,0,170.69,76.42,170.69,170.69v0.92C1321.18,1212.85,1244.76,1289.27,1150.49,1289.27" }),
                                      _createElementVNode("path", {
                                        class: "st1",
                                        d: "M1150.6,1271.75L1150.6,1271.75c-84.84,0-153.62-68.78-153.62-153.62c0-84.84,68.78-153.62,153.62-153.62   c84.84,0,153.62,68.78,153.62,153.62C1304.22,1202.97,1235.44,1271.75,1150.6,1271.75"
                                      }),
                                      _createElementVNode("path", { d: "M1122.34,1107.09c0,13.27-10.76,24.03-24.03,24.03c-13.27,0-24.03-10.76-24.03-24.03c0-13.27,10.76-24.03,24.03-24.03   C1111.58,1083.07,1122.34,1093.82,1122.34,1107.09" }),
                                      _createElementVNode("path", { d: "M1226.92,1107.09c0,13.27-10.76,24.03-24.03,24.03c-13.27,0-24.03-10.76-24.03-24.03c0-13.27,10.76-24.03,24.03-24.03   C1216.16,1083.07,1226.92,1093.82,1226.92,1107.09" }),
                                      _createElementVNode("path", { d: "M1150.35,1184.05c-11.6,0-23.21-4.41-32.04-13.25c-3.04-3.03-3.04-7.96,0-11c3.04-3.04,7.97-3.04,11,0   c11.6,11.6,30.48,11.6,42.07,0c3.04-3.04,7.97-3.04,11,0c3.04,3.04,3.04,7.96,0,11   C1173.56,1179.64,1161.96,1184.05,1150.35,1184.05" })
                                    ], -1)
                                  ])))
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "d-flex justify-center"
                            }, {
                              default: _withCtx(() => _cache[1] || (_cache[1] = [
                                _createElementVNode("div", {
                                  class: "text--secondary",
                                  style: {"width":"80%","text-align":"center"}
                                }, " Nous chargeons votre expérience ", -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}